"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_team-details.scss");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function getRelevantOrganisations(team, organisations) {
  return organisations.filter(function (organisation) {
    return organisation.editingTeam && organisation.editingTeam.teamId === team.teamId;
  });
}

function TeamDetails(_ref) {
  var team = _ref.team,
      organisations = _ref.organisations;
  var organisationsAssignedTo = getRelevantOrganisations(team, organisations);
  return _react.default.createElement("div", {
    className: "team-details"
  }, _react.default.createElement("p", null, _react.default.createElement("strong", null, "ASSIGNED TO")), _react.default.createElement("div", {
    className: "team-details__organisations"
  }, organisationsAssignedTo.length ? organisationsAssignedTo.map(function (organisation) {
    return _react.default.createElement(_uiKit.Image, {
      key: organisation.organisationId,
      imageUrl: organisation.imageUrl,
      width: "50px",
      height: "50px",
      placeholderText: organisation.name,
      placeholderTextSize: 15
    });
  }) : _react.default.createElement("p", null, "None")));
}

var _default = (0, _react.memo)(TeamDetails);

exports.default = _default;